module.exports = "/_next/static/images/wirelineBanner-c7b5068490aff16712fc5426228342ee.webp";